import Card from '@mui/material/Card';

import { AgreedTerms } from './agreed-terms';

// ----------------------------------------------------------------------

export function FormCard({ children, showTerms, sx, ...other }) {
  return (
    <>
      <Card
        sx={[
          {
            p: 3,
            gap: 3,
            display: 'flex',
            flexDirection: 'column',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}
      >
        {children}
      </Card>

      {showTerms && <AgreedTerms />}
    </>
  );
}
